import { render, staticRenderFns } from "./feedbackTemplate.vue?vue&type=template&id=03ed27a3&"
import script from "./feedbackTemplate.vue?vue&type=script&lang=js&"
export * from "./feedbackTemplate.vue?vue&type=script&lang=js&"
import style0 from "./feedbackTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports